import React from "react"
import { Link } from "gatsby"
import slugify from "slugify"
import "./blog-sidebar.scss"

const listStyling = {
  padding: "5px 20px",
  borderRadius: "5px",
  marginBottom: "15px",
  fontSize: "15px",
  backgroundColor: "#08244c",
  fontWeight: "800",
  display: "block",
  border: "1px solid #ccc",
  transition: ".3s",
}

const BlogSidebar = ({ posts, cat }) => {
  const articles = posts
  const categories = cat

  return (
    <div className="blog-sidebar">
      <div className="article-topics pb-5">
        <h2 className="h5 sidebar-heading">Topics</h2>
        <ul className="list-unstyled mb-0">
          {categories.map((c, cIdx) => (
            <li key={cIdx} className="">
              <Link
                to={`/category/${slugify(c.title.toLowerCase())}`}
                style={listStyling}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={15}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="mr-2"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                {c.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="pb-5">
        <h2 className="h5 sidebar-heading">Recent Blogs</h2>
        <ul className="list-unstyled">
          {articles.map((p, pIdx) => (
            <li key={pIdx} className="recent-memo-item">
              <Link
                className="article-title small-title"
                to={`/${p.slug.current}`}
              >
                {p.title}
              </Link>
              <span className="d-block">{p.publishedAt}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default BlogSidebar
